module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_16_9_w_1763.7a55fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_16_9_w_1763.jpg
// module id = 5Sp4
// module chunks = 0